import { render, staticRenderFns } from "./answerSource.vue?vue&type=template&id=40de4d68&scoped=true&"
import script from "./answerSource.vue?vue&type=script&lang=js&"
export * from "./answerSource.vue?vue&type=script&lang=js&"
import style0 from "./answerSource.vue?vue&type=style&index=0&id=40de4d68&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40de4d68",
  null
  
)

export default component.exports